import { render, staticRenderFns } from "./notification-panel.vue?vue&type=template&id=e9e15c96&scoped=true&"
import script from "./notification-panel.vue?vue&type=script&lang=js&"
export * from "./notification-panel.vue?vue&type=script&lang=js&"
import style0 from "./notification-panel.vue?vue&type=style&index=0&id=e9e15c96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e15c96",
  null
  
)

export default component.exports